import { NO, UITextView, UIView } from "uicore-ts"
import { RHBadges, RHColors } from "../Custom components/RH/Utils_slop/RHDesignTokens"
import { RHTextSanitizer } from "../Custom components/RH/Utils_slop/RHTextSanitizer"
import { InvitedCompany } from "../SocketClientFunctions"


export class InvitedCompanyNameView extends UITextView {

    shouldShowContactDetailsInline = NO

    readonly _detailsLabel = new UITextView().configuredWithObject({
        isSingleLine: NO,
        backgroundColor: RHBadges.tooltipBackgroundColor,
        textColor: RHColors.tooltipText,
        containerStyle: {
            borderRadius: RHBadges.tooltipBorderRadius,
            border: RHBadges.tooltipBorder,
            boxShadow: RHBadges.tooltipBoxShadow,
            zIndex: "9999"
        },
        style: {
            fontSize: RHBadges.tooltipFontSize,
            lineHeight: RHBadges.tooltipLineHeight,
            whiteSpace: "pre-wrap",
            overflowWrap: "anywhere",
            userSelect: "text"
        },
        controlEventTargetAccumulator: {
            PointerUpInside: () => this.focus(),
            PointerLeave: () => this._detailsLabel.removeFromSuperview()
        }
    })

    constructor(readonly _detailsSuperview: UIView) {
        super()
        ;(this as InvitedCompanyNameView).configureWithObject({
            isSingleLine: NO,
            containerStyle: { wordBreak: "break-all", hyphens: "auto" },
            style: { lineHeight: "1.6", wordBreak: "break-all", hyphens: "auto" },
            controlEventTargetAccumulator: {
                PointerHover: () => this._showCompanyDetails()
            }
        })
        this._detailsLabel.viewHTMLElement.setAttribute("role", "tooltip")
    }

    updateWithCompany(company: InvitedCompany): void {
        this._detailsLabel.removeFromSuperview()
        const lines = [company.name]
        if (company.email) {
            lines.push(company.email)
        }
        if (company.registryCode) {
            lines.push(company.registryCode)
        }
        this._detailsLabel.text = lines.map(line => RHTextSanitizer.escapedHTML(line)).join("<br>")
        this.text = RHTextSanitizer.escapedHTML(company.name)
        if (this.shouldShowContactDetailsInline) {
            this.text = this._detailsLabel.text
        }
    }

    _showCompanyDetails(): void {
        if (this.shouldShowContactDetailsInline || !this.isMemberOfViewTree) {
            return
        }
        const bounds = this._detailsSuperview.contentBounds
        const companyRectangle = this.viewHTMLElement.getBoundingClientRect()
        const superviewRectangle = this._detailsSuperview.viewHTMLElement.getBoundingClientRect()
        const width = Math.min(RHBadges.tooltipMaxWidth, bounds.width)
        const left = Math.max(0, Math.min(
            (companyRectangle.left - superviewRectangle.left) / UIView.pageScale,
            bounds.width - width
        ))
        const top = (companyRectangle.top - superviewRectangle.top) / UIView.pageScale

        this._detailsLabel.addedAsSubviewToView(this._detailsSuperview)
        this._detailsLabel.weakFrame = bounds
            .rectangleWithWidth(width)
            .rectangleWithHeight(this._detailsLabel)
            .rectangleWithX(left)
            .rectangleWithY(top)
    }

    override wasRemovedFromViewTree(): void {
        super.wasRemovedFromViewTree()
        this._detailsLabel.removeFromSuperview()
    }

}
